import { render, staticRenderFns } from "./WorkArea.vue?vue&type=template&id=62755c51&scoped=true&"
import script from "./WorkArea.vue?vue&type=script&lang=js&"
export * from "./WorkArea.vue?vue&type=script&lang=js&"
import style0 from "./WorkArea.vue?vue&type=style&index=0&id=62755c51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62755c51",
  null
  
)

export default component.exports